import {
  IconPageText,
  GreyGrey70,
  Primary12SemiBold,
  Box
} from '@sequencehq/core-components'
import { InboxListItemContent } from 'Automations/components'
import { LegacyWorkflow, LegacyWorkflowStatus } from '../types'
import { getAutomationStatusIcon } from '../utils/getAutomationStatusIcon'
import { mapLegacyStatusToExecutionStatus } from './legacyWorkflow.adapters'
import { match } from 'ts-pattern'

const getLegacyWorkflowTitle = (status: LegacyWorkflowStatus, label: string) =>
  match(status)
    .with('IN_PROGRESS', () => `Processing ${label}`)
    .with('NEEDS_REVIEW', () => `Schedule ready for review: ${label}`)
    .with('RESOLVED', () => `Schedule for ${label} created`)
    .with('CANCELLED', () => `Review for ${label} cancelled`)
    .with('FAILED', () => `Failed to process ${label}`)
    .exhaustive()

export const LegacyWorkflowItem = ({
  workflow,
  isSelected,
  onClick,
  onPreload,
  'data-testid': dataTestId
}: {
  workflow: LegacyWorkflow
  isSelected: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onPreload?: () => Promise<unknown> | void
  'data-testid'?: string
}) => {
  const displayStatus =
    workflow.status === 'IN_PROGRESS'
      ? ('FAILED' as const)
      : mapLegacyStatusToExecutionStatus(workflow.status)
  const icon = getAutomationStatusIcon(displayStatus)

  const extractionTask = workflow.tasks.find(
    t => t.type === 'CONTRACT_EXTRACTION'
  )
  const fileName =
    extractionTask?.output?.data?.contract?.name ??
    extractionTask?.input?.assetFileName ??
    'contract'

  const title = getLegacyWorkflowTitle(workflow.status, fileName)

  return (
    <InboxListItemContent
      isSelected={isSelected}
      onClick={onClick}
      onPreload={onPreload}
      title={title}
      description={
        <>
          Contract sent for approval by{' '}
          <Box as="span" {...Primary12SemiBold}>
            Contract intake agent
          </Box>
        </>
      }
      createdAt={workflow.createdAt}
      statusIcon={icon}
      data-testid={dataTestId}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <IconPageText color={GreyGrey70} />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
